import { Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import FloatingButtons from './components/FloatingButtons'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Gallery from './pages/Gallery'
import Videos from './pages/Videos'
import Booking from './pages/Booking'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'
import ScrollToTop from './components/ScrollToTop'
import PageLoadReveal from './components/PageLoadReveal'

// Every real route in the app. Anything not in this list falls through to
// the "*" route below and is treated as a 404 — no Navbar/Footer/FloatingButtons.
const KNOWN_ROUTES = ['/', '/about', '/services', '/gallery', '/videos', '/booking', '/contact']

export default function App() {
  const { pathname } = useLocation()
  const isKnownRoute = KNOWN_ROUTES.includes(pathname)

  return (
    <>
      <PageLoadReveal />
      <ScrollToTop />
      {isKnownRoute && <Navbar />}

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {isKnownRoute && <FloatingButtons />}
      {isKnownRoute && <Footer />}
    </>
  )
}